module.exports = __webpack_public_path__ + "static/media/maf-41.c466379e.png";